import Gallery from '../components/galleryComponent/Gallery';

const GalleryPage = () => {
    return <div>
        <Gallery />
    </div>;
};

export default GalleryPage;
